import React, { useEffect, useState } from "react";
import checkMark from "../../../utils/assests/checkMark.png";
import InfoFormP2p from "../../../Common/InfoFormP2p";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { getPortfolioSummaryRequest } from "../Dashboard/dashboardAction";
import { getUserNewDetails } from "../../../utils/localStorage";

const InfoConfirmP2p = () => {
  const dispatch = useDispatch();
  const [user, setUser] = useState<any>(null);
  const {ckycDetails} = useSelector(
    (state: any) => state.personalInfo
  );
  const { dashboardSummary } = useSelector((state: any) => state.dashboard);
  const history = useHistory();

  useEffect(() => {
    dispatch(getPortfolioSummaryRequest());
    setUser(getUserNewDetails());
  }, []);

  const handleSContinue = () => {
    history.push({ pathname: "/p2p/tnc" });
  };

  return (
    <>
      <InfoFormP2p
        imgShow={checkMark}
        title={`welcome to Stashearn <span>${user?.full_name || ckycDetails?.full_name}</span> continue to start investing today!`}
        btnTitle="Continue"
        handleSContinue={handleSContinue}
        showBtn={true}
        errorMessage={dashboardSummary}
      />
    </>
  );
};

export default InfoConfirmP2p;